
























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import FileUpload from "@/components/common/Inputs/FileUpload.vue";

@Component({
  components: {
    FileUpload,
  }
})
export default class TemplateManagerComponent extends Vue {
  search: string = "";
  documents: any = [];
  headers: any = [];
  dialog: boolean = false;
  doc: any = {};
  docTags: any = [];
  refresh = 0;
  snackbar: boolean = false;
  message: string = "";
  snackBarColor: string = "red";

  mounted() {
    this.headers = _app.templateMgrHeader;

    this.$services.template.list().then((res: any) => {
      if (res.Result === "OK") {
        this.documents = res.Record;
      }
    });
  }

  onAddFiles(e: any, doc: any) {
    const { name, type, size } = e;

    let formData = new FormData();
    formData.append("file", e);

    this.$services.template.upload(formData).then((resp: any) => {
      if (resp.Result === "OK") {
        this.dialog = false;
        this.snackbar = true;
        this.snackBarColor = "green";
        this.message = resp.Message;
        this.$services.template.list().then((res: any) => {
          if (res.Result === "OK") {
            this.documents = res.Record;
          }
        });
      } else {
        this.snackbar = true;
        this.snackBarColor = "red";
        this.message = resp.Message;
      }
    });
    // this.refresh += 1;
  }

  deleteItem(item: any) {
    if (confirm("Are you sure to delete this template?")) {
      this.$services.template.delete(item.TemplateId).then((resp: any) => {
        if (resp.Result === "OK") {
          this.snackbar = true;
          this.snackBarColor = "green";
          this.message = resp.Message;
          this.$services.template.list().then((res: any) => {
            if (res.Result === "OK") {
              this.documents = res.Record;
            }
          });
        } else {
          this.snackbar = true;
          this.snackBarColor = "red";
          this.message = resp.Message;
        }
      });
    }
    // this.refresh += 1;
  }

}
